module.exports = {
  API_URL: '',
  WORKSHOP_NOTIFICATION_MAX_LENGTH: 128,
  MAX_FILE_SIZE: 20e6, // maximum file size the user is allowed to pick (in bytes), images are compressed client-side before upload
  MAX_UPLOAD_FILE_SIZE: 10e6, // maximum file size the server accepts (in bytes)
};
